// extracted by mini-css-extract-plugin
module.exports = {"container":"team-about-section-module--container--3rYcz","header":"team-about-section-module--header--1kGSz","text":"team-about-section-module--text--1DF85"};